import Log from 'forms-utils-lib/logger/Logger';
const PREFIX = 'FormsUI:';
export default {
  set(key, value) {
    try {
      localStorage[PREFIX + key] = JSON.stringify(value);
    } catch (e) {
      Log.error(`Local storage set on ${key}${value} failed`);
    }
  },
  delete(key) {
    try {
      delete localStorage[PREFIX + key];
    } catch (e) {
      Log.error(`Local storage delete on ${key} failed`);
    }
  },
  get(key) {
    try {
      return JSON.parse(localStorage[PREFIX + key]);
    } catch (err) {
      return undefined;
    }
  }
};